// tb-cart.js — add ao carrinho via AJAX, toast, contador, barra de compra.
(() => {
  const money = c => 'R$\u00a0' + (c / 100).toFixed(2).replace('.', ',');
  const toast = (html, err) => {
    const root = document.getElementById('tb-toast-root');
    root.innerHTML = `<div class="tb-toast${err ? ' tb-toast--error' : ''}" role="status">${html}</div>`;
    clearTimeout(root._t); root._t = setTimeout(() => (root.innerHTML = ''), 2200);
  };
  document.addEventListener('submit', async e => {
    const form = e.target.closest('[data-tb-add]'); if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button'); btn.setAttribute('aria-busy', 'true');
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: form.id.value, quantity: 1 }] }) });
      if (!r.ok) throw new Error();
      const cart = await (await fetch('/cart.js')).json();
      document.querySelectorAll('[data-tb-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      if (btn.classList.contains('tb-icon-add')) { btn.dataset.state = 'done'; btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="m5 12 5 5L20 7"/></svg>'; setTimeout(() => { delete btn.dataset.state; btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>'; }, 1800); }
      toast(`Pronto! Item na sacola. <a href="/cart">Ver sacola</a>`);
    } catch { toast('Algo deu errado. Tenta de novo?', true); }
    btn.removeAttribute('aria-busy');
  });
  const bar = document.querySelector('[data-tb-buybar]');
  if (bar && 'IntersectionObserver' in window) {
    const target = document.querySelector(bar.dataset.target);
    if (target) new IntersectionObserver(([en]) => bar.classList.toggle('is-hidden', en.isIntersecting), { threshold: 0.3 }).observe(target);
  }
})();
